<jjames-card>
    <div class="p-6">
        <div class="flex justify-between items-start mb-6">
            <div>
                <h2 class="text-2xl font-semibold text-gray-800 mb-2">Create Device Groups</h2>
                <p class="text-sm text-gray-600">
                    Add device groups to the infrastructure.
                    You can skip this step and add them later.
                </p>
            </div>
            <button mat-stroked-button (click)="addDeviceGroup()">
                <mat-icon>add</mat-icon>
                Add Group
            </button>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div formArrayName="deviceGroups" class="space-y-6">
                @for (group of deviceGroups.controls; track $index) {
                <div [formGroupName]="$index" class="p-4 border rounded-lg relative">

                    <button mat-icon-button type="button" (click)="removeDeviceGroup($index)"
                        class="absolute top-2 right-2 text-gray-500 hover:text-red-600">
                        <mat-icon>delete</mat-icon>
                    </button>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <!-- Name -->
                        <mat-form-field appearance="fill">
                            <mat-label>Group Name</mat-label>
                            <input matInput formControlName="name" required>
                            @if (group.get('name')?.hasError('required')) {
                            <mat-error>Name is required</mat-error>
                            }
                        </mat-form-field>

                        <!-- Type -->
                        <mat-form-field appearance="fill">
                            <mat-label>Type</mat-label>
                            <mat-select formControlName="type" required>
                                @for (type of deviceGroupTypes; track type) {
                                <mat-option [value]="type">
                                    {{ type }}
                                </mat-option>
                                }
                            </mat-select>
                            @if (group.get('type')?.hasError('required')) {
                            <mat-error>Type is required</mat-error>
                            }
                        </mat-form-field>

                        <!-- Description -->
                        <mat-form-field appearance="fill" class="md:col-span-2">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>

                </div>
                }
                <!-- Actions -->
                <div class="flex justify-end gap-4 mt-8">
                    <button type="button" mat-stroked-button (click)="onSkip()">
                        Skip
                    </button>
                    <button type="submit" mat-flat-button color="primary"
                        [disabled]="isSaving() || deviceGroups.length === 0">
                        @if (!isSaving()) {
                        <span>Create and Continue</span>
                        }
                        @if (isSaving()) {
                        <span>Creating...</span>
                        }
                    </button>
                </div>
            </div>
        </form>
    </div>
</jjames-card>